import { SUPPORT_EMAIL } from '@/constants/common';
import clsx from 'clsx';
import { Button } from '../../buttons';
import styles from './NotAllowedWarning.module.css';

export const NotAllowedWarning = () => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Restricted Access</h3>
      <p className={clsx(styles.description, styles.generalDescription)}>
        Your account has restricted access and currently only open for payment services such as Bank Transfer, Bill
        Payments.
      </p>

      <Button fluid href={SUPPORT_EMAIL} className={styles.button}>
        Contact Support
      </Button>
    </div>
  );
};
